import React from 'react';

export const SortDownIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="4"
    viewBox="0 0 5 4"
    fill="none"
  >
    <path
      d="M2.80496 3.48692C2.6048 3.74634 2.21338 3.74634 2.01322 3.48692L0.137208 1.05543C-0.116406 0.726724 0.117904 0.25 0.533077 0.25L4.2851 0.25C4.70028 0.25 4.93459 0.726725 4.68097 1.05543L2.80496 3.48692Z"
      fill={active ? '#2B4956' : '#C6C6C6'}
    />
  </svg>
);
